module.exports = "<md-menu #toolbarMenu=\"mdMenu\">\n  <ng-content></ng-content>\n</md-menu>\n\n<button md-icon-button [mdMenuTriggerFor]=\"toolbarMenu\">\n    <md-icon>more_vert</md-icon>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar-menu/toolbar-menu.component.html
// module id = ../../../../../src/app/toolbar/toolbar-menu/toolbar-menu.component.html
// module chunks = 4